module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerNotiApprove.total > 0),
      expression: "headerNotiApprove.total > 0"
    }],
    staticClass: "label label-info"
  }, [_vm._v(_vm._s(_vm.numberFormat(_vm.headerNotiApprove.total)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "noti-header"
  }, [(_vm.headerNotiApprove.total > 0) ? [_vm._v("\n        " + _vm._s(_vm.labels[_vm.nowLang]['new_request1']) + " " + _vm._s(_vm.numberFormat(_vm.headerNotiApprove.total)) + " " + _vm._s(_vm.labels[_vm.nowLang]['new_request2']) + "\n      ")] : [_vm._v("\n        " + _vm._s(_vm.labels[_vm.nowLang]['no_request']) + "\n      ")]], 2), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "approve-list"
  }, _vm._l((_vm.headerNotiApprove.rows), function(headerApp) {
    return _c('li', [_c('div', {
      staticClass: "pull-left approve-box"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: headerApp.key
        }
      }
    }, [_c('div', {
      staticClass: "approve-icon-box"
    }, [_c('i', {
      staticClass: "fa fa-flag-o"
    })]), _vm._v(" "), _c('div', {
      staticClass: "approve-topic-box clearfix"
    }, [_c('div', {
      staticClass: "approve-topic"
    }, [_vm._v(_vm._s(headerApp.values))]), _vm._v(" "), (headerApp.summary == 1) ? _c('div', {
      staticClass: "approve-detail-box"
    }, [_vm._v(_vm._s(headerApp.summary) + " " + _vm._s(_vm.labels[_vm.nowLang]['new_request3']))]) : (headerApp.summary > 1 && headerApp.summary <= 999) ? _c('div', {
      staticClass: "approve-detail-box"
    }, [_vm._v(_vm._s(headerApp.summary) + " " + _vm._s(_vm.labels[_vm.nowLang]['new_request4']))]) : _c('div', {
      staticClass: "approve-detail-box"
    }, [_vm._v("999+ " + _vm._s(_vm.labels[_vm.nowLang]['new_request4']))])])])], 1)])
  }))]), _vm._v(" "), _c('li', {
    staticClass: "footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'managerapprove'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.labels[_vm.nowLang]['view_all']) + "\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50d8805e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/headers/HeaderApprove.vue
// module id = 3752
// module chunks = 1